module.exports = __webpack_public_path__ + "img/FutebolDeRua.12df44eb.jpg";